import React, { memo } from "react";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
// import CircleIcon from "@material-ui/icons/Brightness1";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import EvalBarChart from "./EvalBarChart";
import EvalTable from "./EvalTable";

// const COLORS = ["#0088FE", "#00C49F", "#FFBB28", "#FF8042", "#ff0000"];

const useStyles = makeStyles((theme) => ({
  root: {
    marginBottom: theme.spacing(6),
    marginTop: theme.spacing(6),
    [theme.breakpoints.down("sm")]: {
      marginTop: theme.spacing(2),
    },
  },
  column: {
    borderBottom: "1px solid #c2c2c2",
    marginBottom: 64,
  },
  contents: {
    paddingLeft: theme.spacing(2.5),
    paddingRight: theme.spacing(2.5),
    width: "100%",
    marginBottom: 12,
  },
  body: {
    backgroundColor: "#ffffff",
    paddingTop: theme.spacing(5),
    paddingBottom: theme.spacing(5),
    paddingLeft: theme.spacing(4.75),
    paddingRight: theme.spacing(4.75),
    border: "1px solid #e0ebff",
  },
  form: {
    marginTop: 12,
  },
  grap: {
    height: 300,
  },
}));

const ResultList = memo(({ datas, survey, que, handleChange }) => {
  const classes = useStyles();
  const cancerFor = (num = 6, data) => {
    if (data.cancerName === "폐암") {
      for (let index = 0; index < num; index++) {
        if (data.que[index] === 0) {
          totalData[index][0]["폐암"] = totalData[index][0]["폐암"] + 1;
          if (data.sex) {
            totalData[index][0].lungStat.man =
              totalData[index][0].lungStat.man + 1;
          } else {
            totalData[index][0].lungStat.woman =
              totalData[index][0].lungStat.woman + 1;
          }
          if (data.smoking) {
            totalData[index][0].lungStat.smoke =
              totalData[index][0].lungStat.smoke + 1;
          } else {
            totalData[index][0].lungStat.smokeNo =
              totalData[index][0].lungStat.smokeNo + 1;
          }
        } else if (data.que[index] === 1) {
          totalData[index][1]["폐암"] = totalData[index][1]["폐암"] + 1;
          if (data.sex) {
            totalData[index][1].lungStat.man =
              totalData[index][1].lungStat.man + 1;
          } else {
            totalData[index][1].lungStat.woman =
              totalData[index][1].lungStat.woman + 1;
          }
          if (data.smoking) {
            totalData[index][1].lungStat.smoke =
              totalData[index][1].lungStat.smoke + 1;
          } else {
            totalData[index][1].lungStat.smokeNo =
              totalData[index][1].lungStat.smokeNo + 1;
          }
        } else if (data.que[index] === 2) {
          totalData[index][2]["폐암"] = totalData[index][2]["폐암"] + 1;
          if (data.sex) {
            totalData[index][2].lungStat.man =
              totalData[index][2].lungStat.man + 1;
          } else {
            totalData[index][2].lungStat.woman =
              totalData[index][2].lungStat.woman + 1;
          }
          if (data.smoking) {
            totalData[index][2].lungStat.smoke =
              totalData[index][2].lungStat.smoke + 1;
          } else {
            totalData[index][2].lungStat.smokeNo =
              totalData[index][2].lungStat.smokeNo + 1;
          }
        } else if (data.que[index] === 3) {
          totalData[index][3]["폐암"] = totalData[index][3]["폐암"] + 1;
          if (data.sex) {
            totalData[index][3].lungStat.man =
              totalData[index][3].lungStat.man + 1;
          } else {
            totalData[index][3].lungStat.woman =
              totalData[index][3].lungStat.woman + 1;
          }
          if (data.smoking) {
            totalData[index][3].lungStat.smoke =
              totalData[index][3].lungStat.smoke + 1;
          } else {
            totalData[index][3].lungStat.smokeNo =
              totalData[index][3].lungStat.smokeNo + 1;
          }
        } else if (data.que[index] === 4) {
          totalData[index][4]["폐암"] = totalData[index][4]["폐암"] + 1;
          if (data.sex) {
            totalData[index][4].lungStat.man =
              totalData[index][4].lungStat.man + 1;
          } else {
            totalData[index][4].lungStat.woman =
              totalData[index][4].lungStat.woman + 1;
          }
          if (data.smoking) {
            totalData[index][4].lungStat.smoke =
              totalData[index][4].lungStat.smoke + 1;
          } else {
            totalData[index][4].lungStat.smokeNo =
              totalData[index][4].lungStat.smokeNo + 1;
          }
        }
      }
    } else {
      for (let index = 0; index < num; index++) {
        if (data.que[index] === 0) {
          totalData[index][0]["전립선암"] = totalData[index][0]["전립선암"] + 1;
          if (data.sex) {
            totalData[index][0].prosStat.man =
              totalData[index][0].prosStat.man + 1;
          } else {
            totalData[index][0].prosStat.woman =
              totalData[index][0].prosStat.woman + 1;
          }
          if (data.smoking) {
            totalData[index][0].prosStat.smoke =
              totalData[index][0].prosStat.smoke + 1;
          } else {
            totalData[index][0].prosStat.smokeNo =
              totalData[index][0].prosStat.smokeNo + 1;
          }
        } else if (data.que[index] === 1) {
          totalData[index][1]["전립선암"] = totalData[index][1]["전립선암"] + 1;
          if (data.sex) {
            totalData[index][1].prosStat.man =
              totalData[index][1].prosStat.man + 1;
          } else {
            totalData[index][1].prosStat.woman =
              totalData[index][1].prosStat.woman + 1;
          }
          if (data.smoking) {
            totalData[index][1].prosStat.smoke =
              totalData[index][1].prosStat.smoke + 1;
          } else {
            totalData[index][1].prosStat.smokeNo =
              totalData[index][1].prosStat.smokeNo + 1;
          }
        } else if (data.que[index] === 2) {
          totalData[index][2]["전립선암"] = totalData[index][2]["전립선암"] + 1;
          if (data.sex) {
            totalData[index][2].prosStat.man =
              totalData[index][2].prosStat.man + 1;
          } else {
            totalData[index][2].prosStat.woman =
              totalData[index][2].prosStat.woman + 1;
          }
          if (data.smoking) {
            totalData[index][2].prosStat.smoke =
              totalData[index][2].prosStat.smoke + 1;
          } else {
            totalData[index][2].prosStat.smokeNo =
              totalData[index][2].prosStat.smokeNo + 1;
          }
        } else if (data.que[index] === 3) {
          totalData[index][3]["전립선암"] = totalData[index][3]["전립선암"] + 1;
          if (data.sex) {
            totalData[index][3].prosStat.man =
              totalData[index][3].prosStat.man + 1;
          } else {
            totalData[index][3].prosStat.woman =
              totalData[index][3].prosStat.woman + 1;
          }
          if (data.smoking) {
            totalData[index][3].prosStat.smoke =
              totalData[index][3].prosStat.smoke + 1;
          } else {
            totalData[index][3].prosStat.smokeNo =
              totalData[index][3].prosStat.smokeNo + 1;
          }
        } else if (data.que[index] === 4) {
          totalData[index][4]["전립선암"] = totalData[index][4]["전립선암"] + 1;
          if (data.sex) {
            totalData[index][4].prosStat.man =
              totalData[index][4].prosStat.man + 1;
          } else {
            totalData[index][4].prosStat.woman =
              totalData[index][4].prosStat.woman + 1;
          }
          if (data.smoking) {
            totalData[index][4].prosStat.smoke =
              totalData[index][4].prosStat.smoke + 1;
          } else {
            totalData[index][4].prosStat.smokeNo =
              totalData[index][4].prosStat.smokeNo + 1;
          }
        }
      }
    }
  };
  const totalData = {
    0: [
      {
        name: "전혀그렇지않다",
        전립선암: 0,
        폐암: 0,
        prosStat: {
          man: 0,
          woman: 0,
          smoke: 0,
          smokeNo: 0,
        },
        lungStat: { man: 0, woman: 0, smoke: 0, smokeNo: 0 },
      },
      {
        name: "조금 아쉽다",
        전립선암: 0,
        폐암: 0,
        prosStat: {
          man: 0,
          woman: 0,
          smoke: 0,
          smokeNo: 0,
        },
        lungStat: { man: 0, woman: 0, smoke: 0, smokeNo: 0 },
      },
      {
        name: "보통이다",
        전립선암: 0,
        폐암: 0,
        prosStat: {
          man: 0,
          woman: 0,
          smoke: 0,
          smokeNo: 0,
        },
        lungStat: { man: 0, woman: 0, smoke: 0, smokeNo: 0 },
      },
      {
        name: "만족한다",
        전립선암: 0,
        폐암: 0,
        prosStat: {
          man: 0,
          woman: 0,
          smoke: 0,
          smokeNo: 0,
        },
        lungStat: { man: 0, woman: 0, smoke: 0, smokeNo: 0 },
      },
      {
        name: "매우 만족한다",
        전립선암: 0,
        폐암: 0,
        prosStat: {
          man: 0,
          woman: 0,
          smoke: 0,
          smokeNo: 0,
        },
        lungStat: { man: 0, woman: 0, smoke: 0, smokeNo: 0 },
      },
    ],
    1: [
      {
        name: "매우 짧다",
        전립선암: 0,
        폐암: 0,
        prosStat: {
          man: 0,
          woman: 0,
          smoke: 0,
          smokeNo: 0,
        },
        lungStat: { man: 0, woman: 0, smoke: 0, smokeNo: 0 },
      },
      {
        name: "조금 짧다",
        전립선암: 0,
        폐암: 0,
        prosStat: {
          man: 0,
          woman: 0,
          smoke: 0,
          smokeNo: 0,
        },
        lungStat: { man: 0, woman: 0, smoke: 0, smokeNo: 0 },
      },
      {
        name: "적당하다",
        전립선암: 0,
        폐암: 0,
        prosStat: {
          man: 0,
          woman: 0,
          smoke: 0,
          smokeNo: 0,
        },
        lungStat: { man: 0, woman: 0, smoke: 0, smokeNo: 0 },
      },
      {
        name: "조금 길다",
        전립선암: 0,
        폐암: 0,
        prosStat: {
          man: 0,
          woman: 0,
          smoke: 0,
          smokeNo: 0,
        },
        lungStat: { man: 0, woman: 0, smoke: 0, smokeNo: 0 },
      },
      {
        name: "매우 길다",
        전립선암: 0,
        폐암: 0,
        prosStat: {
          man: 0,
          woman: 0,
          smoke: 0,
          smokeNo: 0,
        },
        lungStat: { man: 0, woman: 0, smoke: 0, smokeNo: 0 },
      },
    ],
    2: [
      {
        name: "매우 부족하다",
        전립선암: 0,
        폐암: 0,
        prosStat: {
          man: 0,
          woman: 0,
          smoke: 0,
          smokeNo: 0,
        },
        lungStat: { man: 0, woman: 0, smoke: 0, smokeNo: 0 },
      },
      {
        name: "조금 부족하다",
        전립선암: 0,
        폐암: 0,
        prosStat: {
          man: 0,
          woman: 0,
          smoke: 0,
          smokeNo: 0,
        },
        lungStat: { man: 0, woman: 0, smoke: 0, smokeNo: 0 },
      },
      {
        name: "적당하다",
        전립선암: 0,
        폐암: 0,
        prosStat: {
          man: 0,
          woman: 0,
          smoke: 0,
          smokeNo: 0,
        },
        lungStat: { man: 0, woman: 0, smoke: 0, smokeNo: 0 },
      },
      {
        name: "조금 많다",
        전립선암: 0,
        폐암: 0,
        prosStat: {
          man: 0,
          woman: 0,
          smoke: 0,
          smokeNo: 0,
        },
        lungStat: { man: 0, woman: 0, smoke: 0, smokeNo: 0 },
      },
      {
        name: "매우 많다",
        전립선암: 0,
        폐암: 0,
        prosStat: {
          man: 0,
          woman: 0,
          smoke: 0,
          smokeNo: 0,
        },
        lungStat: { man: 0, woman: 0, smoke: 0, smokeNo: 0 },
      },
    ],
    3: [
      {
        name: "검진을 권장하는 것 같다.",
        전립선암: 0,
        폐암: 0,
        prosStat: {
          man: 0,
          woman: 0,
          smoke: 0,
          smokeNo: 0,
        },
        lungStat: { man: 0, woman: 0, smoke: 0, smokeNo: 0 },
      },
      {
        name: "스스로 결정하게 한다",
        전립선암: 0,
        폐암: 0,
        prosStat: {
          man: 0,
          woman: 0,
          smoke: 0,
          smokeNo: 0,
        },
        lungStat: { man: 0, woman: 0, smoke: 0, smokeNo: 0 },
      },
      {
        name: "검진을 권장하지 않는 것 같다",
        전립선암: 0,
        폐암: 0,
        prosStat: {
          man: 0,
          woman: 0,
          smoke: 0,
          smokeNo: 0,
        },
        lungStat: { man: 0, woman: 0, smoke: 0, smokeNo: 0 },
      },
    ],
    4: [
      {
        name: "전혀 도움 안된다.",
        전립선암: 0,
        폐암: 0,
        prosStat: {
          man: 0,
          woman: 0,
          smoke: 0,
          smokeNo: 0,
        },
        lungStat: { man: 0, woman: 0, smoke: 0, smokeNo: 0 },
      },
      {
        name: "별로 도움 안된다.",
        전립선암: 0,
        폐암: 0,
        prosStat: {
          man: 0,
          woman: 0,
          smoke: 0,
          smokeNo: 0,
        },
        lungStat: { man: 0, woman: 0, smoke: 0, smokeNo: 0 },
      },
      {
        name: "매우 도움된다",
        전립선암: 0,
        폐암: 0,
        prosStat: {
          man: 0,
          woman: 0,
          smoke: 0,
          smokeNo: 0,
        },
        lungStat: { man: 0, woman: 0, smoke: 0, smokeNo: 0 },
      },
      {
        name: "조금 도움된다",
        전립선암: 0,
        폐암: 0,
        prosStat: {
          man: 0,
          woman: 0,
          smoke: 0,
          smokeNo: 0,
        },
        lungStat: { man: 0, woman: 0, smoke: 0, smokeNo: 0 },
      },
      {
        name: "잘 모르겠다",
        전립선암: 0,
        폐암: 0,
        prosStat: {
          man: 0,
          woman: 0,
          smoke: 0,
          smokeNo: 0,
        },
        lungStat: { man: 0, woman: 0, smoke: 0, smokeNo: 0 },
      },
    ],
    5: [
      {
        name: "전혀 그렇지 않다",
        전립선암: 0,
        폐암: 0,
        prosStat: {
          man: 0,
          woman: 0,
          smoke: 0,
          smokeNo: 0,
        },
        lungStat: { man: 0, woman: 0, smoke: 0, smokeNo: 0 },
      },
      {
        name: "그렇지 않다",
        전립선암: 0,
        폐암: 0,
        prosStat: {
          man: 0,
          woman: 0,
          smoke: 0,
          smokeNo: 0,
        },
        lungStat: { man: 0, woman: 0, smoke: 0, smokeNo: 0 },
      },
      {
        name: "조금 그렇다",
        전립선암: 0,
        폐암: 0,
        prosStat: {
          man: 0,
          woman: 0,
          smoke: 0,
          smokeNo: 0,
        },
        lungStat: { man: 0, woman: 0, smoke: 0, smokeNo: 0 },
      },
      {
        name: "매우 그렇다",
        전립선암: 0,
        폐암: 0,
        prosStat: {
          man: 0,
          woman: 0,
          smoke: 0,
          smokeNo: 0,
        },
        lungStat: { man: 0, woman: 0, smoke: 0, smokeNo: 0 },
      },
      {
        name: "잘 모르겠다",
        전립선암: 0,
        폐암: 0,
        prosStat: {
          man: 0,
          woman: 0,
          smoke: 0,
          smokeNo: 0,
        },
        lungStat: { man: 0, woman: 0, smoke: 0, smokeNo: 0 },
      },
    ],
    total: 0,
  };
  survey.list.forEach((data) => {
    totalData.total++;
    cancerFor(6, data);
  });
  return (
    <>
      <Grid
        container
        justify="space-between"
        alignItems="center"
        direction="column"
        className={classes.root}
      >
        <Grid container direction="column" className={classes.column}>
          <Typography variant="caption" align="right">
            &nbsp;총참여자 {totalData.total}명&nbsp;
          </Typography>
          <Typography variant="h6">
            1. 해당 영상에 대해 전반적으로 만족하십니까?
          </Typography>
          <EvalBarChart totalData={totalData[0]} />
          <Box display="flex" p={1} mb={5}>
            <EvalTable totalData={totalData[0]} />
          </Box>
        </Grid>
        <Grid container direction="column" className={classes.column}>
          <Typography variant="h6">2. 영상의 길이는 적당하였습니까?</Typography>
          <EvalBarChart totalData={totalData[1]} />
          <Box display="flex" p={1} mb={5}>
            <EvalTable totalData={totalData[1]} />
          </Box>
        </Grid>
        <Grid container direction="column" className={classes.column}>
          <Typography variant="h6">
            3. 영상에 포함된 정보의 양은 적당하였습니까?
          </Typography>
          <EvalBarChart totalData={totalData[2]} />
          <Box display="flex" p={1} mb={5}>
            <EvalTable totalData={totalData[2]} />
          </Box>
        </Grid>
        <Grid container direction="column" className={classes.column}>
          <Typography variant="h6">
            4. 영상에 포함 된 정보의 방향성은 어떠셨습니까?
          </Typography>
          <EvalBarChart totalData={totalData[3]} />
          <Box display="flex" p={1} mb={5}>
            <EvalTable totalData={totalData[3]} />
          </Box>
        </Grid>
        <Grid container direction="column" className={classes.column}>
          <Typography variant="h6">
            5. 영상을 시청한 이후, 추후 검진을 결정하는 데에 도움이 되었다고
            생각하십니까?
          </Typography>
          <EvalBarChart totalData={totalData[4]} />
          <Box display="flex" p={1} mb={5}>
            <EvalTable totalData={totalData[4]} />
          </Box>
        </Grid>
        <Grid container direction="column" className={classes.column}>
          <Typography variant="h6">
            6. 영상을 시청한 이후, 스스로 검진에 대한 결정을 자신있게 내리실 수
            있게 되었습니까?
          </Typography>
          <EvalBarChart totalData={totalData[5]} />
          <Box display="flex" p={1} mb={5}>
            <EvalTable totalData={totalData[4]} />
          </Box>
          {/* <Box display="flex" p={1} mb={5}>
            <Box p={1} flexGrow={1}>
              <Grid container alignItems="center">
                <CircleIcon
                  style={{ fontSize: 15, paddingRight: 4, color: COLORS[0] }}
                />
                <Typography>전혀 그렇지 않다&nbsp;</Typography>
                <CircleIcon
                  style={{ fontSize: 15, paddingRight: 4, color: COLORS[1] }}
                />
                <Typography>그렇지 않다&nbsp;</Typography>
                <CircleIcon
                  style={{ fontSize: 15, paddingRight: 4, color: COLORS[2] }}
                />
                <Typography>조금 그렇다&nbsp;</Typography>
                <CircleIcon
                  style={{ fontSize: 15, paddingRight: 4, color: COLORS[3] }}
                />
                <Typography>매우 그렇다&nbsp;</Typography>
                <CircleIcon
                  style={{ fontSize: 15, paddingRight: 4, color: COLORS[4] }}
                />
                <Typography>잘 모르겠다&nbsp;</Typography>
              </Grid>
            </Box>
          </Box> */}
        </Grid>
      </Grid>
    </>
  );
});

export default ResultList;
